const TIMEZONE_PREF_KEY = 'hdp-evidence-timezone-mode';

export function getTimezoneMode() {
  if (typeof window === 'undefined') return 'local';
  return localStorage.getItem(TIMEZONE_PREF_KEY) || 'local';
}

export function setTimezoneMode(mode) {
  if (typeof window === 'undefined') return;
  localStorage.setItem(TIMEZONE_PREF_KEY, mode === 'gmt' ? 'gmt' : 'local');
}

export function parseUtcIso(isoString) {
  if (!isoString) return null;
  const raw = String(isoString).trim();
  const normalized = /[zZ]|[+-]\d{2}:\d{2}$/.test(raw) ? raw : `${raw}Z`;
  const date = new Date(normalized);
  return Number.isNaN(date.getTime()) ? null : date;
}

export function getLocalTimezoneLabel() {
  try {
    const parts = new Intl.DateTimeFormat(undefined, { timeZoneName: 'short' })
      .formatToParts(new Date());
    return parts.find((part) => part.type === 'timeZoneName')?.value || 'Local';
  } catch {
    return 'Local';
  }
}

export function formatEvidenceTimestamp(isoString, mode = getTimezoneMode()) {
  const date = parseUtcIso(isoString);
  if (!date) return '—';

  if (mode === 'gmt') {
    const value = new Intl.DateTimeFormat('en-GB', {
      timeZone: 'UTC',
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit',
      hour12: false,
    }).format(date);
    return `${value} UTC`;
  }

  return new Intl.DateTimeFormat(undefined, {
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit',
    hour12: false,
    timeZoneName: 'short',
  }).format(date);
}

export function timestampColumnSuffix(mode, localLabel = getLocalTimezoneLabel()) {
  return mode === 'gmt' ? 'UTC' : localLabel;
}
